"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 77: Irem LROG017 (Napoleon Senki)
 * ------------------------------------------------------------------ *
 * Singleton board Irem built for Napoleon Senki. One 8-bit register is
 * latched by any write to $8000-$FFFF:
 *
 *   [CCCC PPPP]   PPPP = 2 KB CHR ROM bank for PPU $0000-$07FF
 *                 CCCC = 32 KB PRG bank for CPU $8000-$FFFF
 *
 * The register writing is subject to BUS CONFLICTS: the PRG ROM still
 * drives the bus at the written address while the CPU drives its data,
 * so the value the latch really captures is the AND of both. Games
 * arrange their writes so the two agree; emulating the AND also keeps
 * stray writes harmless.
 *
 * The rest of the pattern-table space is 6 KB of CHR RAM carried by the
 * cart, and the board wires the cart's own 4 KB of VRAM behind the PPU
 * as four independent name tables (the header says four-screen):
 *
 *   $0000-$07FF  CHR ROM (bank selected)
 *   $0800-$1FFF  CHR RAM
 *   $2000-$2FFF  four independent name tables
 *   $3000-$3FFF  open bus
 *
 * Used by Napoleon Senki (Japan).
 * Reference: https://www.nesdev.org/wiki/INES_Mapper_077
 * Mesen: Core/IremLrog017.h
 */

function register(Mappers) {
  Mappers[77] = function (nes) {
    this.nes = nes;
  };

  Mappers[77].prototype = new Mappers[0]();

  Mappers[77].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
    this.chrBank = 0;
  };

  Mappers[77].prototype.write = function (address, value) {
    if (address >= 0x8000) {
      // Bus conflicts: the currently mapped ROM byte at the written
      // address is still on the PPU/CPU bus, so the latch captures the
      // AND. Read it before the banking below replaces that bank.
      value &= this.nes.cpu.mem[address];

      this.prgBank = value & 0x0f;
      this.chrBank = (value >> 4) & 0x0f;
      this.updateBanks();
      return;
    }

    Mappers[0].prototype.write.apply(this, arguments);
  };

  Mappers[77].prototype.updateBanks = function () {
    // 32 KB PRG bank (the helper wraps to the ROM size).
    this.load32kRomBank(this.prgBank, 0x8000);
    // 2 KB CHR ROM window at $0000; $0800-$1FFF stays CHR RAM, which the
    // PPU keeps writable and is not touched here (no loadCHRROM).
    this.load2kVromBank(this.chrBank, 0x0000);
  };

  Mappers[77].prototype.loadROM = function () {
    if (!this.nes.rom.valid || this.nes.rom.romCount < 1) {
      throw new Error("Irem LROG017: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadPRGROM();
    this.load2kVromBank(0, 0x0000);
    this.setMirroring(this.nes.rom.FOURSCREEN_MIRRORING);
    this.resetIrqHandler();
  };

  Mappers[77].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank = this.prgBank;
    s.chrBank = this.chrBank;
    return s;
  };

  Mappers[77].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank = s.prgBank;
    this.chrBank = s.chrBank;
    this.updateBanks();
  };
}

module.exports = { register: register };
